export const de = {
  HOME: '/',
  CONTENT: '/[...content]',
  NEWS_LISTING: '/nachrichten',
  NEWS_LISTING_BY_SLUG: '/nachrichten/auflistung/[newsListing]',
  NEWS_CATEGORY: '/nachrichten/kategorie/[category]',
  NEWS_TAG: '/nachrichten/stichwort/[tag]',
  ARTICLE: '/nachrichten/[article]',
  MATCH_CENTRE: '/spiele/[team]/[fixture]',
  FIXTURES: '/spiele/[team]/spielplan',
  FIXTURES_COMPETITION: '/spiele/[team]/spielplan/[competition]',
  RESULTS: '/spiele/[team]/ergebnisse',
  RESULTS_COMPETITION: '/spiele/[team]/ergebnisse/[competition]',
  RESULTS_COMPETITION_SEASON:
    '/spiele/[team]/ergebnisse/[competition]/[season]',
  TABLE: '/spiele/[team]/tabelle',
  TABLE_COMPETITION: '/spiele/[team]/tabelle/[competition]',
  TABLE_COMPETITION_SEASON: '/spiele/[team]/tabelle/[competition]/[season]',
  TEAM: '/teams/[team]',
  PROFILE: '/teams/[team]/[profile]',
  TEAM_YOUTH: '/teams/jugend/[team]',
  PROFILE_YOUTH: '/teams/jugend/[team]/[profile]',
  VIDEO_LANDING: '/video',
  VIDEO_DETAIL: '/video/[slug]',
  VIDEO_CATEGORY: '/video/kategorie/[category]',
  VIDEO_PLAYLIST_LISTING: '/video/wiedergabelisten',
  VIDEO_PLAYLIST: '/video/wiedergabelisten/[slug]',
  VIDEO_COLLECTION: '/video/sammlung/[collection]',
} as const;
